import apiService from 'config/service';
import { TFreightCard, TTruckerItem } from 'context/reducers/truckers.type';

export type IGetTruckerTypeReturn = {
  data: TTruckerItem[];
  meta: TFreightCard;
};

export const fetchPage = (id: string, radius: number, page: number): Promise<IGetTruckerTypeReturn> =>
  apiService.get(`/freights/${id}/truckers?radius=${radius}&page=${page}&forceSearch=0`);

export const fetchTruckerList = (id: string, radius: number): Promise<IGetTruckerTypeReturn> =>
  apiService.get(`/freights/${id}/truckers?radius=${radius}&forceSearch=1`);

export const bindSearch = (payload: { encodedFreightId: string; vehicleId: string; personUuid: string }) => {
  apiService.post(`/truckers/bind-search-tag`, payload);
};
